import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer2} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import {PieChartComponent} from '@swimlane/ngx-charts';

@Component({
  selector: 'app-cost-projection-details',
  templateUrl: './cost-projection-details.component.html',
  styleUrls: ['./cost-projection-details.component.css']
})
export class CostProjectionDetailsComponent implements OnInit {
  @ViewChild(PieChartComponent) pieChart: PieChartComponent;
  title: string;
  titleDescription: string;
  hcCostTitle: string;
  hcCostDescription: string;
  hcDataV2: any;
  public p1CostsV2: any;
  public p2CostsV2: any;
  view: any;
  FrmPV: number;
  hCBreakDownNote: string;
  public partnerActive: boolean = false;
  public pieChartData: any[];
  public pieChartOptions = {
    showLegend: false,
    colorScheme: { domain: ['#0B4C8E','#20a59f', '#3385C5', '#D6E1EF', '#9CE6E5', '#047388', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }
    
  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: false,
    timeline: false,
    curve: false,
    tooltipDisabled: false,
    view: [900, 500],
    colorScheme: {
      domain: ['#20a59f', '#0B4C8E', '#bad052']
    },
    autoScale: true,
  }
  public lineChartData: any[];
  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }


  constructor(
    private _renderer: Renderer2,
    private _el: ElementRef,
    public dialogRef: MatDialogRef<CostProjectionDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) data
    ) { 
    this.title = "Cost Projection Details"
    this.titleDescription = "Below is a breakdown of healthcare costs by type of coverage. It is assumed that Medicare Part A hospitalization premiums are funded through payroll deductions during employment and do not factor into projections."
    this.hCBreakDownNote = "Note: 46% of overall costs (Part B Premiums, Part B Surcharges, and Part D Surcharges) are automatically deducted from Social Security beneﬁts."
    this.hcCostTitle = "Healthcare Cost Inflation"
    this.hcCostDescription = "Healthcare cost inflation needs to be considered when projecting how much you need to save for retirement. The chart below shows the projected rate of healthcare inflation through John and Jane’s retirement."
    this.hcDataV2 = data.hcDataV2;
    this.partnerActive = data.partnerActive;
    this.FrmPV = data.FrmPV;
    this.view = [innerWidth / 2.4, 400];
  }

  ngOnInit() {
    this.generatePieChartData();
    this.generateLineChartData();

  }
  ngAfterViewInit() {
    const line = this._el.nativeElement.querySelectorAll('.line')[1];
  }

  generatePieChartData() {
    let tempCostsV2;
    this.p1CostsV2 = JSON.parse(this.FrmPV == 0 ? this.hcDataV2.P1HealthCareExpensesDiscounted : this.hcDataV2.P1HealthCareExpenses);
    this.p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? this.hcDataV2.P2HealthCareExpensesDiscounted : this.hcDataV2.P2HealthCareExpenses) : {};
    tempCostsV2 = this.p1CostsV2;
    
    if (this.p1CostsV2[0].Total == 0) {
      var tempCosts = [];

      for (var item in this.p2CostsV2) {
        if (this.p2CostsV2[item].Total != 0) {
          tempCosts.push(this.p2CostsV2[item]);
        }
      }

      this.p1CostsV2 = tempCosts;
    }
    let TotalYear1OOP = Math.round((this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0));

    this.pieChartData = [
      { "name": "Part B Premiums (doctor visits and tests) - " + Utils.formatToCurrency(Math.round(this.p1CostsV2[0].Premiums[0])) , "value": Math.round(this.p1CostsV2[0].Premiums[0]) }, 
      { "name": "Part B Surcharges - " + Utils.formatToCurrency(Math.round(this.p1CostsV2[0].PartDSurcharge)), "value": Math.round(this.p1CostsV2[0].PartDSurcharge) },
      { "name": "Part D Premiums (prescription drugs) - "+ Utils.formatToCurrency(Math.round(this.p1CostsV2[0].Premiums[1])), "value": Math.round(this.p1CostsV2[0].Premiums[1]) },
      { "name": "Part D Surcharges - " + Utils.formatToCurrency(Math.round(this.p1CostsV2[0].PartDSurcharge)), "value": Math.round(this.p1CostsV2[0].PartDSurcharge) },
      { "name": "Medigap - " + Utils.formatToCurrency(Math.round(this.p1CostsV2[0].Premiums[2])), "value": Math.round(this.p1CostsV2[0].Premiums[2]) },
      { "name": "Out-of-Pocket Costs - " + Utils.formatToCurrency(TotalYear1OOP), "value": TotalYear1OOP },
    ]
  }
  generateLineChartData() {   

    if (this.hcDataV2) { 

      let currentYear = new Date().getFullYear();
      let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;

      this.lineChartData = [
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear + i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'John'+"'"+'s Healthcare Cost Inflation', series: []}),
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear +1+ i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'Jane'+"'"+'s Healthcare Cost Inflation', series: []})];
        
    }
  }
  formatNumber(amount) {
    return Math.round(amount);
  }
  close(): void {
    this.dialogRef.close();
  }


}
